import Img from "gatsby-image";

import { withProps } from "recompose";

const ImgWithPolyfills = withProps(
  ({ objFit = "cover", objPosition = "50% 50%", imgStyle = {} }) => ({
    imgStyle: {
      ...imgStyle,
      fontFamily: `"object-fit: ${objFit}; object-position: ${objPosition}`,
    },
  })
)(Img);

export default ImgWithPolyfills;



// WEBPACK FOOTER //
// ./src/components/ImgWithPolyfills.js